<template>
  <div id="systemFeedback" class="page-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>系统反馈</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <el-row style="margin-bottom: 8px;" v-if="type.editStatus">
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-plus" @click="newAdd" v-if="type.logintype != 'ADMIN' || type.logintype == 'KEFU'" size="small">新增</el-button>
          <div v-else style="color: white;">
            1
          </div>
        </el-col>
        <el-col :span="12">
          <div style="float: right;position: relative;">
            <el-input v-model="title" placeholder="请输入内容" style="width: 320px;position: relative;" size="small"></el-input>
            <el-button icon="el-icon-search" type="text" style="position: absolute;left: 295px;top: -3px;" @click="oneStep(1)"></el-button>
          </div>
        </el-col>
      </el-row>

      <el-table ref="multipleTable"
      :data="tableData"
      header-row-class-name="data-table-header-style"
      tooltip-effect="dark"
      style="width: 100%"
      @row-click="detil">
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="反馈标题">
          <template slot-scope="scope">
            <span style="color: red;font-size: 20px;font-weight: 900;margin-right: 5px;"
            v-show="
            type.logintype == 'ADMIN' && scope.row.adminstatus == 0 ||
            type.logintype == 'HCM' && scope.row.accepttype==1 && scope.row.userstatus == 0 ||
            type.logintype == 'HCM' && scope.row.accepttype==2 && scope.row.adminstatus== 0 ||
            type.logintype == 'HCMSUB' && scope.row.accepttype==1 && scope.row.userstatus == 0 ||
            type.logintype == 'HCMSUB' && scope.row.accepttype==2 && scope.row.adminstatus== 0 ||
            type.logintype == 'DEALER' && scope.row.userstatus == 0 ||
            type.logintype == 'SHOP' && scope.row.userstatus == 0
            ">·</span>
            <span style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
              {{scope.row.work_title}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="提交用户" v-if="type.logintype == 'ADMIN'">
        </el-table-column>
        <el-table-column prop="details" label="内容">
          <template slot-scope="scope">
            <div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
              {{scope.row.details}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="接收方" v-if="type.logintype == 'DEALER' || type.logintype == 'SHOP'">
          <template slot-scope="scope">
            <span v-if="scope.row.accepttype == '1'">
              系统管理员
            </span>
            <span v-else>
              品牌方
            </span>
          </template>
        </el-table-column>
        <el-table-column label="来源" v-if="type.logintype == 'HCM'">
          <template slot-scope="scope">
            <span v-if="scope.row.accepttype == '1'">
              我给管理员的反馈
            </span>
            <span v-else>
              来自经销商的反馈
            </span>
          </template>
        </el-table-column>
        <el-table-column label="回复时间">
          <template slot-scope="scope">
            {{ scope.row.updatetime | formatDate}}
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        title: '',
        multipleSelection: [],
        totalNum: 10,
        type: {},
        wahaha: true,
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    mounted() {
      this.oneStep()
      this.type = JSON.parse(window.localStorage.userData)
      console.log(this.type.logintype)
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      oneStep(e) {
        if (e == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.title) {
          params.title = this.title;
        }
        fetch({
          url: "hcm/hcmWorkOrder/getListWorkOrder",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.currentPage = 1

            this.tableData = data.content
            this.totalNum = data.totalElements
            console.log(this.tableData.length)
          }
        })
      },
      detailsTitle(f) {
        this.$router.push({
          path: '/urlMonitorDetails',
          query: { id: f }
        })
      },
      newAdd() {
        this.$router.push({
          path: '/NewFeedback',
        })
      },
      detil(row) {
        this.$router.push({
          path: '/feedbackDetilis',
          query: { id: row.id ,name: row.work_title}
        })
      },
    },
    components: {
        pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 28px;
    line-height: 28px;
    background-color: white;
  }
  .page {
    margin: 20px;
    background-color: white;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }

</style>
<style lang="scss">
#systemFeedback {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
